import { fetcher } from '@commenda/utils';
import { TBillingBundleSaleDependencyInput } from './types';

export const replaceBillingBundleDependencies = async (
  bundleId: string,
  dependencies: TBillingBundleSaleDependencyInput[]
) =>
  fetcher(`commenda-billing/catalog/bundles/${bundleId}/sale-dependencies`, {
    method: 'PUT',
    body: { dependencies },
  });
